





















































































import { Component, Mixins } from "vue-property-decorator";
import InvoicePanel from "@/components/invoices/InvoicePanel.vue";
import MonthPicker from "@/components/ui/MonthPicker.vue";

import { DataOptions } from "vuetify/types";
import moment from "moment";
import { translate } from "@/utils";

import { LinkMixin } from "@/mixins/LinkMixin";
import FormValidator from "@/mixins/FormValidator";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";

import { InvoicesModule } from "@/store/invoices.module";
import { ContractsModule } from "@/store/contracts.module";

@Component({
  components: { InvoicePanel, MonthPicker },
  watch: {
    from: "onFiltersChange",
    to: "onFiltersChange",
    options: "getInvoiceItems",
    invoicesStatusFilter: "onFiltersChange",
  },
})
export default class InvoicesView extends Mixins(
  LinkMixin,
  FormValidator,
  ContractIdValidatorMixin,
) {
  formRef = "form";
  from = "";
  to = "";
  min = "";
  current = "";
  options: DataOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  };
  invoicesStatusFilter: number = 0;

  async mounted() {
    this.current = moment().format("YYYY-MM");
    this.min = "2019-01";
    this.to = this.current;
    this.from = moment()
      .subtract(12, "months")
      .format("YYYY-MM");

    await this.validateContractId();

    InvoicesModule.getInvoiceStatuses();
    this.getInvoiceItems();
  }

  get loading() {
    return InvoicesModule.loading;
  }

  get noDataText() {
    return this.$t("ui.no_data_for_period");
  }

  get invoices() {
    return translate(InvoicesModule.invoices);
  }

  get itemsLength() {
    if (!this.invoices.length) return 0;
    return this.invoices[0].row_count;
  }

  onFiltersChange() {
    this.options.page = 1;
    this.getInvoiceItems();
  }

  private async getInvoiceItems() {
    if (!this.from || !this.to) return;
    const options = {
      contractRid: ContractsModule.selectedContract,
      startDate: moment(this.from, "YYYY-MM")
        .startOf("month")
        .format("YYYYMMDD"),
      endDate: moment(this.to, "YYYY-MM")
        .startOf("month")
        .format("YYYYMMDD"),
      status: this.invoicesStatusFilter,
      offset: (this.options?.page - 1) * this.options?.itemsPerPage || 0,
      limit: this.options?.itemsPerPage || 10,
    };
    InvoicesModule.setInvoicesLoading(true);
    await InvoicesModule.getInvoices(options);
  }

  get invoiceStatuses() {
    let statuses: any[] = translate(InvoicesModule.statuses);
    const statusAll = statuses.find(({ status }) => status === 0);

    // sorting statuses alphabetically
    statuses.sort((a: any, b: any) => {
      if (a.name < b.name) {
        // only one comparison since values are unique
        return -1;
      }
      return 1;
    });

    // putting status "All" first
    const statusAllIndex = statuses.indexOf(statusAll);
    statuses.splice(statusAllIndex, 1);
    statuses = [statusAll, ...statuses];
    return statuses;
  }

  validateDates() {
    if (!this.from) return true;
    if (moment(this.from).isAfter(this.to))
      return this.$t("reportsInfo.initial_period_later_than_final");
    else return true;
  }
}
